import React from "react";
import ReactDOM from "react-dom";
// import App from "./App";

import "bootstrap/dist/js/bootstrap.min.js";
import "jquery";
// import "./assets/js/main.js";
import "bootstrap/dist/js/bootstrap.js";
//   import "bootstrap/dist/css/bootstrap.min.css"; 
import "./assets/css/bootstrap.css";
import "./assets/css/sb-admin-2.css";
import "./assets/css/material-design-iconic-font.min.css";
import "./assets/css/main.css";
import "./assets/css/custom.css";
import "./assets/css/anil-style.css";

import configureAppStore from "./config/configure-store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

const { store, persistor } = configureAppStore();

const render = () => {
	const App = require("./App").default;

	ReactDOM.render(
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<App />
			</PersistGate>
		</Provider>,
		document.getElementById("root")
	);
};

render();

if (process.env.NODE_ENV === "development" && module.hot) {
	module.hot.accept("./App", render);
}

